// packages/ui/src/sidebar/registerBuiltinPanels.tsx
import { FolderTree } from 'lucide-react';
import type { PlatformBridge, ToolHost } from '@slate/core';
import { SidebarPanelRegistry } from './SidebarPanelRegistry';
import { ExplorerPanel } from './ExplorerPanel';

/**
 * Register the built-in sidebar panels. Called once from App with the live
 * platform/host; returns an unregister fn. Today only the Explorer panel; adding
 * Workspace and others later is one more `register` call here.
 */
export function registerBuiltinSidebarPanels(
  platform: PlatformBridge,
  host: ToolHost,
): () => void {
  return SidebarPanelRegistry.register({
    id: 'explorer',
    title: 'Explorer',
    icon: FolderTree,
    order: 0,
    Component: ({ active }) => <ExplorerPanel active={active} platform={platform} toolHost={host} />,
  });
}
